import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import TopBar from './TopBar';
import TemplateUploadProgressModal from '../UI/TemplateUploadProgressModal';

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', minWidth: 0 }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <TopBar />
        <Toolbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            p: { xs: 1.5, sm: 2, md: 3 },
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
            // Last-resort guardrail: a stray fixed-width child must never make
            // the whole document scroll sideways. Individual tables are made
            // fluid so this should never hide real content.
            overflowX: 'hidden',
          }}
        >
          <Outlet />
        </Box>
      </Box>
      {/* Global modal that shows live progress + status comparison for every
          "Upload Template" flow while the import request is running. */}
      <TemplateUploadProgressModal />
    </Box>
  );
};

export default Layout;
